import { createTheme } from '@mui/material';

export const Z_INDEX = {
  MAP: 400,
  MAP_ATTRIBUTION: 401,
  CUSTOM_CONTROLS: 1201,
  SIDEBAR: 3000
};

export const theme = createTheme({
  typography: {
    fontFamily: ['Montserrat', 'Arial', 'sans-serif'].join(','),
    button: {
      textTransform: 'none'
    }
  },
  palette: {
    primary: {
      main: 'rgba(255, 137, 61, 1)'
    }
  }
});
